import React, { useEffect } from "react";
import MainReturnButton from "../../UI/MainReturnButton";
import LeftMenu from "../../UI/LeftMenu";
import "../../styles/Appeals.css";
import { INFO_ROUTES } from "../../utils/consts";
import { titleName } from "../../store/routes";
const Appeals = () => {
  useEffect(() => {
    document.title = "Обращения граждан" + titleName;
  }, []);

  return (
    <div>
      <h2 className="header-h2">Обращения граждан</h2>
      <MainReturnButton />
      <div className="appeals">
        <LeftMenu arr={INFO_ROUTES} />
        <div className="appeals-content">
          <h3>
            Телефон доверия по противодействию хищениям, коррупции и
            мошенничеству
            <br /> +375 44 513 67 82
          </h3>
          <h3>
            Электронная почта для обращений граждан:
            <a href="mailto:kztsh-info@tut.by">kztsh-info@tut.by</a>
          </h3>
          <h4>
            "Соблюдение требований законодательства и внутренних правил является
            приоритетной задачей для ОАО «КЗТШ».
          </h4>
          <p>
            В целях предупреждения неправомерных действий в ОАО «КЗТШ» работает
            "Телефон доверия" по фактам коррупционной направленности,
            предназначенный для своевременного выявления и предотвращения
            хищений, фактов коррупционных проявлений и правонарушений, создающих
            условия для коррупции, мошенничества. Работники предприятия, а также
            иные лица могут использовать его, чтобы сообщить о нарушениях
            законов или правил внутреннего распорядка на предприятии. В
            нерабочее время можно оставить сообщения об указанных нарушениях на
            голосовую почту.
          </p>
          <ul>
            Перечень случаев, рассматриваемых по «телефону доверия»:
            <li>
              <span>
                хищение или неправомерное использование имущества и активов;
              </span>
            </li>
            <li>
              <span>получение взяток;</span>
            </li>
            <li>
              <span>наличие конфликта интересов у работников предприятия;</span>
            </li>
            <li>
              <span>
                искажение бухгалтерской (финансовой) и управленческой
                отчетности;
              </span>
            </li>
            <li>
              <span>незаконные финансовые операции.</span>
            </li>
          </ul>
          <p>
            При обработке сообщений, мы гарантируем полную конфиденциальность.
          </p>
          <ul>
            При обращении по телефону доверия:
            <li>
              <span>Указать подразделение, в котором произошло нарушение.</span>
            </li>
            <li>
              <span>
                Дать характеристику нарушения и указать известные вам факты.
              </span>
            </li>
            <li>
              <span>
                Указать оценку возможного ущерба или иную дополнительную
                информацию.
              </span>
            </li>
            <li>
              <span>Указать Ваше имя (по желанию).</span>
            </li>
            <li>
              <span>Указать контактные данные (по желанию).</span>
            </li>
          </ul>
          <p>
            Так же Вы можете отправить своё сообщение на электронный адрес:{" "}
            <a href="mailto:seb-kztsh@mail.ru">seb-kztsh@mail.ru</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Appeals;
